import type { RouteLocationNormalized } from 'vue-router';
import { useDataPortalAuthStore } from './data-portal-auth.store';

export async function dataPortalAuthGuard(to: RouteLocationNormalized) {
  if (!to.matched.some((record) => record.meta.requiresDataPortalAuth))
    return true;

  const auth = useDataPortalAuthStore();
  const authenticated = await auth.loadUser();
  if (authenticated) {
    const adminOnly = to.matched.some(
      (record) => record.meta.requiresDataPortalAdmin,
    );
    if (adminOnly && !auth.user?.roles.includes('data-portal-admin'))
      return { name: 'data-portal-forbidden' };
    return true;
  }
  if (auth.status === 'forbidden') {
    return { name: 'data-portal-forbidden' };
  }
  if (auth.status === 'unavailable') {
    return { name: 'data-portal-unavailable' };
  }
  return {
    name: 'data-portal-login',
    query: { returnTo: to.fullPath },
  };
}
